import toCapitalize from '@/filters/toCapitalize';
import timeFormatL from '@/filters/timeFormatL';
import timeFormatAmPm from '@/filters/timeFormatAmPm';
import currencySign from '@/filters/currencySign';
import priceFormat from '@/filters/priceFormat'
import dateFormat from '@/filters/dateFormat'
import phone from '@/filters/phone';
import phoneUK from '@/filters/phoneUK';
import timeFormatInvoices from '@/filters/timeFormatInvoices';

export default {
    toCapitalize,
    timeFormatL,
    timeFormatAmPm,
    currencySign,
    priceFormat,
    dateFormat,
    phone,
    phoneUK,
    timeFormatInvoices
};


// WEBPACK FOOTER //
// ./src/filters/filters.js